class FeaturedDealsCarousel {
  constructor(track) {
    this.track = track;
    this.isDragging = false;
    this.dragMoved = false;
    this.startX = 0;
    this.scrollLeft = 0;
    this.onPointerDown = (event) => this.handlePointerDown(event);
    this.onPointerMove = (event) => this.handlePointerMove(event);
    this.onPointerEnd = (event) => this.handlePointerEnd(event);
    this.onClickCapture = (event) => this.handleClickCapture(event);
    this.init();
  }

  init() {
    this.track.addEventListener('pointerdown', this.onPointerDown);
    this.track.addEventListener('pointermove', this.onPointerMove);
    this.track.addEventListener('pointerup', this.onPointerEnd);
    this.track.addEventListener('pointercancel', this.onPointerEnd);
    this.track.addEventListener('click', this.onClickCapture, true);
  }

  handlePointerDown(event) {
    if (event.button !== 0) return;

    this.isDragging = true;
    this.dragMoved = false;
    this.startX = event.clientX;
    this.scrollLeft = this.track.scrollLeft;
    this.track.classList.add('is-dragging');
    this.track.setPointerCapture(event.pointerId);
  }

  handlePointerMove(event) {
    if (!this.isDragging) return;

    const distance = event.clientX - this.startX;
    if (Math.abs(distance) > 3) this.dragMoved = true;
    this.track.scrollLeft = this.scrollLeft - distance;
  }

  handlePointerEnd(event) {
    if (!this.isDragging) return;

    this.isDragging = false;
    this.track.classList.remove('is-dragging');
    if (this.track.hasPointerCapture(event.pointerId)) {
      this.track.releasePointerCapture(event.pointerId);
    }
  }

  handleClickCapture(event) {
    if (!this.dragMoved) return;
    event.preventDefault();
    event.stopPropagation();
    this.dragMoved = false;
  }
}

function initFeaturedDealsCarousels(scope = document) {
  scope.querySelectorAll('[data-featured-deals-carousel]:not([data-carousel-ready])').forEach((track) => {
    track.dataset.carouselReady = 'true';
    new FeaturedDealsCarousel(track);
  });
}

document.addEventListener('DOMContentLoaded', () => initFeaturedDealsCarousels());

document.addEventListener('shopify:section:load', (event) => {
  initFeaturedDealsCarousels(event.target);
});
